// extracted by mini-css-extract-plugin
var _1 = "UTcf1uXJ1GxhJVur3MhD";
export { _1 as "action" }
export default { "action": _1 }
